import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { IPortSolicitudPerfil } from '@/modules/Portal/interfaces'

// Endpoints: /api/v1/portal/solicitudes-perfil/*
// search/view existen por BaseService; aprobar y rechazar se agregan aquí.
export class SolicitudPerfilService extends BaseService<IPortSolicitudPerfil> {
  constructor () {
    super({ baseUrl: 'portal/solicitudes-perfil/' })
  }

  /** Aprueba solo los datos marcados (`campos` = atributos). Si quedan datos sin marcar, `respuesta` es obligatoria. */
  async aprobar (
    pospId: number,
    campos: string[],
    respuesta?: string
  ): Promise<AxiosResponse<IResponseApi<IPortSolicitudPerfil>>> {
    return this.http.put<IResponseApi<IPortSolicitudPerfil>>(
      `/aprobar/${pospId}`,
      respuesta ? { campos, respuesta } : { campos }
    ).catch(this.errorHandle)
  }

  async rechazar (
    pospId: number,
    respuesta: string
  ): Promise<AxiosResponse<IResponseApi<IPortSolicitudPerfil>>> {
    return this.http.put<IResponseApi<IPortSolicitudPerfil>>(
      `/rechazar/${pospId}`,
      { respuesta }
    ).catch(this.errorHandle)
  }
}
